import { useQuery } from "@tanstack/react-query";
import API from "../api/api";

export default function useDashboard() {
  return useQuery({
    queryKey: ["dashboard"],
    queryFn: async () => {
      const res = await API.get("/dashboard");
      return res.data;
    },
    staleTime: 1000 * 60, // 1 min cache
    retry: 1
  });
}